import appData from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';
import PostData from '../../RestAPI/fetchData';

const fetchChaptersWithPremiumAndFreeCount = async data => {
  return await GetData.callAPI(
    `${appData.backend_api}/exams/cfa/notes/chapter-wise-notes-count`,
    data,
  );
};

const downloadFormulaSheet = async data => {
  return await GetData.callAPI(
    `${appData.backend_api}/api/exams/cfa/notes/pdf-download-via-email`,
    data,
  );
};
const fetchLastNoteRead = async (data = {}) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/cfa/notes/last-answered-notes`, data);
};
const fetchAdditionalResourcesPdf = async (data = {}) => {
  return await PostData.callAPI(
    `${appData.backend_api}/exams/cfa/notes/additional-resources`,
    data,
  );
};
module.exports = {
  fetchChaptersWithPremiumAndFreeCount,
  fetchLastNoteRead,
  downloadFormulaSheet,
  fetchAdditionalResourcesPdf,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ApiService.js